
export default class StoreFormController {

	constructor (zones, Store, $state) {
		this.Store = Store;
		this.$state = $state;
		this.zones = zones;
		this.store = { zone : zones[0].id };

	}

	back () {
		this.$state.go('storesPage');
	}

	submit () {
		this.Store.create(
				this.store
			).then(this.back.bind(this));
	}

}

StoreFormController.$inject = ['zones', 'Store', '$state'];



// WEBPACK FOOTER //
// ./src/page/storeForm/storeForm.controller.js